import { QueryClient } from '@tanstack/react-query';
import { resolveQueryRetry } from './data/query/queryRetry';

/**
 * Single QueryClient instance for the app.
 * Reuse this in tests by importing from here (or inject a different instance for testing).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: (failure_count, error) => resolveQueryRetry(failure_count, error, 3),
    },
  },
});
